/* eslint-disable */
// lint to be fixed in this ticket: https://lastbrand.atlassian.net/browse/ECOMP-3295
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/order */
/*
 * TODO: IMPORTANT IMPORTANT IMPORTANT
 * DO NOT CHANGE THE ORDER OF IMPORTS HERE IT WILL BREAK THE BUILD
 *
 * import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'
 */
import { LOCAL_STORAGE_NEW_CART_ID_KEY } from '../../../services/checkoutService/new-checkout.constants'
import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'

import { LineItemDetails } from '@src/quince-site-common/src/organisms/appLayout/molecules/cartPopUp/cart.helper'
import {
  Cart,
  CartLineItem,
  PromoAllocation,
} from '@src/quince-site-common/src/services/cartService/cart.service.types'

import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { INVENTORY_STATUS } from '@src/quince-site-common/src/services/cartService/cart.service.constants'
import { getStorage } from '@src/utils/enhancedStorage'

export function getLineItem(newCheckout: Cart) {
  return newCheckout?.lineItems
}

export function getLineItemId(lineItem: CartLineItem) {
  return lineItem?.variantId
}

export function getSvidFromEdge(edge: CartLineItem) {
  return edge?.productMetaData?.svid
}

export function getSpid(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.spid
}

export function getSelectedOptionsFromLineItem(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.options
}

export function getLineItemsSubtotalPriceAmount(node?: Cart) {
  return node?.cartCostSummary?.subTotalAmount
}
export function getLineItemsCurrencyCode(node: Cart) {
  return node?.currencyCode || ''
}

export function getSubtotalPriceV2(node: Cart) {
  return node?.cartCostSummary?.totalAmount
}

export function getLineItemEdges(node: Cart) {
  return node?.lineItems
}

export function getSaveForLaterItems(node: Cart) {
  return node?.saveForLaterItems
}

export function getOutOfStockItems(node: Cart) {
  return node?.outOfStockLineItems || []
}

export function getProductID(lineItem?: CartLineItem) {
  return lineItem?.variantMetaData?.productId
}

export function getVariantId(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantId
}

export function getSvid(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.svid
}

export function getVariantSelectedOptions(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.options
}

export function getVariantIdFromEdge(edge: CartLineItem) {
  return edge?.variantId
}

export function getVariantProductIdFromEdge(edge: any) {
  return edge?.lineItem?.variantId
}

export function getVariantProductId(node: any) {
  return node?.lineItem?.variantId
}

export function getIdFromEdge(edge: CartLineItem) {
  return edge.id
}

export function getQuantityFromEdge(edge: CartLineItem): number | undefined {
  return edge?.quantity
}

export function getLineItemFromEdge(edge?: CartLineItem): CartLineItem | undefined {
  return edge
}

export function getLineItemDetails(lineItems: CartLineItem[]): Record<string, LineItemDetails> {
  return lineItems.reduce((acc: Record<string, LineItemDetails>, curr) => {
    const { variantId: internalVariantId, productId: internalProductId, price } = curr.variantMetaData || {}

    const variantTitle = curr.variantMetaData?.variantTitle || ''
    const splitVariantTitle = variantTitle.split(' / ')
    const hasSizeAndColor = splitVariantTitle.length > 1
    const color = hasSizeAndColor ? splitVariantTitle[1] || '' : ''
    const size = hasSizeAndColor ? splitVariantTitle[0] || '' : ''
    const ignoredVariants = [...ignoredVariantsUS, ...ignoredVariantsCA].map(variant => variant.toLowerCase())

    let productLink = curr.slug ? `/${curr.slug}` : ''
    if (productLink) {
      const queryParams: string[] = []

      if (color) {
        queryParams.push(`color=${encodeURIComponent(color.toLowerCase())}`)
      }
      if (size && !ignoredVariants.includes(size.toLowerCase())) {
        queryParams.push(`size=${encodeURIComponent(size.toLowerCase())}`)
      }

      if (queryParams.length > 0) {
        productLink += `?${queryParams.join('&')}`
      }
    }

    return {
      ...acc,
      [curr.variantId]: {
        productLink,
        internalVariantId,
        internalProductId,
        price,
      },
    }
  }, {})
}

export function getIsAnyItemOutOfStock(lineItems: any[]) {
  return lineItems?.some(
    lineItem =>
      lineItem?.inventoryStatus === INVENTORY_STATUS.OUT_OF_STOCK ||
      lineItem?.inventoryStatus === INVENTORY_STATUS.PARTIAL_OUT_OF_STOCK,
  )
}

export function getQuantityAvailableFromLineItem(lineItem: CartLineItem) {
  return lineItem?.inventoryData?.available
}

export function getProductFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData
}

export function getProductTitleFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.productTitle
}

const ignoredVariantsUS: string[] = ['One Size', 'default', 'One Color', 'No Color']
const ignoredVariantsCA: string[] = [
  // fr-ca
  'Taille unique',
  'par défaut',
  'Une couleur',
  'Aucune couleur',

  // for en-ca
  'One Size',
  'default',
  'One Colour',
  'No Colour',
]

export function getVariantTitleFromLineItem(lineItem: CartLineItem) {
  // replace One Size, default, One Color, No Color with empty string
  // same is being shown in CA as well

  let variantTitle = lineItem?.variantMetaData?.variantTitle || ''

  // replace the changes
  ;[...ignoredVariantsUS, ...ignoredVariantsCA].forEach((variant: string) => {
    const regex = new RegExp(variant, 'gi')
    variantTitle = variantTitle?.replace(regex, '')
  })

  return variantTitle
    ?.split(' / ')
    .filter(title => Boolean(title))
    .join(' / ')
}

export function getCustomAttributes(lineItem?: CartLineItem) {
  return lineItem?.attributes || []
}

export function getProductImageFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.imageUrl
}

export function getPreOrderShippingData(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.imageUrl
}

export function getSvMetaField(lineItem: CartLineItem) {
  const quantityAvailable = getQuantityAvailableFromLineItem(lineItem)

  const { inventoryData } = lineItem
  return {
    svMetaField: inventoryData,
    shippingDate: inventoryData?.tags?.preOrderShippingDate,
    quantityAvailable,
  }
}

export function getVariantPrice(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.price
}

export function getProductTitleFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.productTitle
}

export function getVariantTitleFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantTitle
}

export function getVariantSkuFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantTitle
}

export function getVarientId(variant: any) {
  return variant?.id
}

export function isEqualId(id: string, filterIdForVariant: string) {
  return id === filterIdForVariant
}

export function getCartIDAndAuth() {
  return {
    cartID: isBrowser() ? getStorage().getItem(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false }) : null,
    authCode: getCartAuthCodeFromHeader(),
  }
}

export const getCheckoutToken = (): string => {
  const { cartID } = getCartIDAndAuth()
  return cartID ?? ''
}

export function getCreatedAt(lineItem: CartLineItem) {
  return lineItem?.createdAt
}

export function getDiscountAllocations(lineItem: CartLineItem): PromoAllocation[] {
  return (
    lineItem?.costSummary?.promoAllocations.filter(
      promoAllocation =>
        promoAllocation.promoType === 'MONEY_DISCOUNT' || promoAllocation.promoType === 'SUBSCRIPTION_DISCOUNT',
    ) || []
  )
}

export function getDiscountTitle(allocation: PromoAllocation, tCommon: any) {
  if (allocation.promoType === 'SUBSCRIPTION_DISCOUNT' && tCommon) {
    return tCommon('subscribe_and_save')
  }
  return allocation?.promoCode
}

export function getDiscountAmount(allocation: PromoAllocation) {
  return allocation?.amount
}

/**
 * Get subscription discount amount for a line item
 * @param lineItem - The cart line item
 * @returns The subscription discount amount, or 0 if none
 */
export function getSubscriptionDiscount(lineItem: CartLineItem): number {
  const subscriptionAllocation = lineItem?.costSummary?.promoAllocations.find(
    alloc => alloc.promoType === 'SUBSCRIPTION_DISCOUNT',
  )
  return subscriptionAllocation?.amount ?? 0
}

const DEFAULT_MAX_QUANTITY = 50
const DEFAULT_SUBSCRIPTION_MAX_QUANTITY = 10

export function getMaxQuantity(lineItem: CartLineItem): number {
  if (lineItem.purchaseMode === 'RECURRING') {
    return lineItem.variantMetaData?.subscriptionMaxQuantity ?? DEFAULT_SUBSCRIPTION_MAX_QUANTITY
  }
  return DEFAULT_MAX_QUANTITY
}

export function isSubscriptionLineItem(lineItem: CartLineItem): boolean {
  return lineItem.purchaseMode === 'RECURRING'
}

export function isSubscriptionEligible(lineItem: CartLineItem): boolean {
  return lineItem.purchaseMode !== 'RECURRING' && lineItem.variantMetaData?.isSubscribable === true
}

export function getSpidForLineItem(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.spid
}

export function getSwatchesId(lineItem: any) {
  return lineItem?.variantId
}
export function getSwatchesIdFromLineItem(lineItem: any) {
  return lineItem?.variantId
}
export const getpayloadForRemoveLineItems = (lineItem: any) => {
  return {
    lineItemId: getIdFromEdge(lineItem),
    adjustment: -1,
  }
}

export function getSubscriptionFrequencyLabel(
  plans: Array<{ id?: number; planId?: number; frequency: { interval: number; unit: string } }> | undefined,
  targetPlanId: number | null | undefined,
): string | null {
  if (!plans || !targetPlanId) return null
  const plan = plans.find(p => (p.id ?? p.planId) === targetPlanId)
  return plan ? `${plan.frequency.interval} ${plan.frequency.unit}` : null
}

export function getProductPayload(
  lineItems: CartLineItem[] = [],
  position: 'active' | 'saved_for_later' | 'out_of_stock' = 'active',
) {
  if (!lineItems) return []
  return lineItems.map((item, index) => {
    return {
      product_id: item.productMetaData?.spid ?? item.variantMetaData?.productId,
      variant_id: item.variantId,
      quantity: item.quantity,
      price: item.costSummary?.totalAmount,
      is_of_subscription_nature: item.purchaseMode === 'RECURRING',
      subscription_frequency: getSubscriptionFrequencyLabel(
        item.variantMetaData?.plans,
        item.subscriptionDetail?.subscriptionPlanId,
      ),
      product_position: position,
      page_number: index + 1,
    }
  })
}

/* eslint-enable */
